/** Paid plans include legacy `growth` (same tier as Premium). */
export function isPaidPlan(plan?: string | null): boolean {
  return (
    plan === "premium" || plan === "custom" || plan === "growth"
  );
}

/**
 * Effective paid access: custom/growth always; premium only while not expired.
 * Matches server `isPaidAccess` (manual premium without expiry counts as active).
 */
export function isPaidAccess(user?: {
  plan?: string | null;
  subscription?: { premiumExpiresAt?: string | null } | null;
} | null): boolean {
  if (!user?.plan) return false;
  if (user.plan === "custom" || user.plan === "growth") return true;
  if (user.plan === "premium") {
    const exp = user.subscription?.premiumExpiresAt;
    if (exp == null || exp === undefined) return true;
    return new Date(exp) > new Date();
  }
  return false;
}

export function planLabel(plan?: string | null): string {
  if (!plan || plan === "free") return "Free";
  if (plan === "growth") return "Premium";
  return plan.charAt(0).toUpperCase() + plan.slice(1);
}
